import { EMAIL_LAYOUTS } from "@/rbac/links.js";
import {
  CREATE_EMAIL_LAYOUT,
  VIEW_EMAIL_LAYOUT,
  UPDATE_EMAIL_LAYOUT,
} from "@/rbac/permissions.js";

const emailLayoutRoutes = [
  {
    path: "/email-layouts",
    component: () =>
      import(
        /* webpackChunkName: "system-layout" */ "@/views/system/Layout.vue"
      ),
    children: [
      {
        path: "",
        name: "EmailLayoutIndex",
        meta: { title: "Email Layouts", permission: EMAIL_LAYOUTS },
        props: (route) => ({
          page: parseInt(route.query.page) || 1,
          limit: parseInt(route.query.limit) || 10,

          id: parseInt(route.query.id) || null,
          order_by_id: route.query.order_by_id || null,

          name: route.query.name || null,
          order_by_name: route.query.order_by_name || null,
          order_by_created_at: route.query.order_by_created_at || null,
          order_by_updated_at: route.query.order_by_updated_at || null,
        }),
        component: () =>
          import(
            /* webpackChunkName: "email-layout-index" */ "@/views/system/email-layout/Index.vue"
          ),
      },
      {
        path: "create",
        name: "EmailLayoutCreate",
        meta: { title: "Create Email Layout", permission: CREATE_EMAIL_LAYOUT },
        component: () =>
          import(
            /* webpackChunkName: "email-layout-create" */ "@/views/system/email-layout/Create.vue"
          ),
      },
      {
        path: ":id/view",
        name: "EmailLayoutView",
        meta: { title: "View Email Layout", permission: VIEW_EMAIL_LAYOUT },
        props: (route) => ({
          id: parseInt(route.params.id),
        }),
        component: () =>
          import(
            /* webpackChunkName: "email-layout-view" */ "@/views/system/email-layout/View.vue"
          ),
      },
      {
        path: ":id/edit",
        name: "EmailLayoutEdit",
        meta: { title: "Edit Email Layout", permission: UPDATE_EMAIL_LAYOUT },
        props: (route) => ({
          id: parseInt(route.params.id),
        }),
        component: () =>
          import(
            /* webpackChunkName: "email-layout-edit" */ "@/views/system/email-layout/Edit.vue"
          ),
      },
    ],
  },
];

export default emailLayoutRoutes;
